import script from "./ProfileSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileSettings.vue?vue&type=script&setup=true&lang=js"

import "./ProfileSettings.vue?vue&type=style&index=0&id=38d935d3&lang=css"

const __exports__ = script;

export default __exports__